import React, { Component } from 'react';
import autoBind from 'react-autobind';
import WindowComponent from '@common/components/dialog/window.component';
import sessionStorageUtils from '@common/helpers/sessionStorage.utils';
import EnumSistemasRelatorio from '../relatorioGerencial/enumSistemasRelatorio';

class WindowManagerComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: '',
      windowStage: 'DEFAULT',
      isResizable: true,
      initialHeight: 647,
      initialWidth: 654,
      maxWidth: 500,
      minWidth: 300,
      minHeight: 200,
    };
    autoBind(this);
  }

  render() {
    const { component, closeWindow } = this.props;
    const { title, minWidth, minHeight, initialWidth, initialHeight, maxWidth, isResizable, windowStage } = this.state;

    const idSistema = sessionStorageUtils.getSistema();
    const fromTb = Number(idSistema) === EnumSistemasRelatorio.TB;

    return (
      component && (
        <div style={{ zIndex: fromTb ? '554' : '5555' }} className="window-container">
          {component.map(
            (x) =>
              x.visible && (
                <WindowComponent
                  key={x.id}
                  id={x.id}
                  title={x.title ?? title}
                  height={x.height}
                  width={x.width}
                  minWidth={x.minWidth ?? minWidth}
                  minHeight={x.minHeight ?? minHeight}
                  initialWidth={x.initialWidth ?? initialWidth}
                  initialHeight={x.initialHeight ?? initialHeight}
                  maxWidth={x.maxWidth ?? maxWidth}
                  isResizable={x.isResizable ?? isResizable}
                  windowStage={x.windowStage ?? windowStage}
                  closeWindow={closeWindow}
                  highlighted={x.highlighted}
                  component={x.component}
                />
              )
          )}
        </div>
      )
    );
  }
}

export default WindowManagerComponent;
